// eslint-disable-next-line no-unused-vars
import { ILanguage } from './ILanguage';

export default {
  title: 'Our team',
  text: `Over one hundred Nobel Prizes have gone to brilliant Germans for accomplishments in physics,
  medicine, chemistry, literature and other areas. That is not even counting the prizes awarded to people
  from the other two major German-speaking countries Austria and Switzerland. Plus, many of the recipients
  from other nations received their training at German universities. So if you are looking to add a Nobel
  Prize to your resume, learning German might not be a bad place to start. Perhaps you have slightly lower
  goals, and are just looking to absorb some of this genius by reading famous publications in their native
  language.`,
} as ILanguage;
